<template>
	<div>
		<div class="pgntfound-container text-center">
			<div class="pgntfound-subcontainer">
				<img src="../../assets/404icon.svg" alt="" />
				<div class="pg-nt-foundtxt mt-3 ml-5">Page Not Found</div>
				<div class="pgntfound-note mt-3 ml-3">
					We're sorry, there is a problem with the page you’re trying to find.
				</div>
				<div class="mt-3">
					<b-button class="addbtn pl-5 pr-5" @click="Back()"> Back </b-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "PageNotFound",
	methods: {
		Back() {
			this.$router.go(-1);
		},
	},
};
</script>

<style>
.pgntfound-subcontainer {
	position: absolute;
	left: 40%;
	top: 40%;
	transform: translate(-60px, -60px);
}
.pgntfound-container {
	position: relative;
	height: 100vh;
}
.pgntfound-note {
	font-weight: 400;
	font-size: 16px;
	color: #72738e;
}
.pg-nt-foundtxt {
	font-weight: 500;
	font-size: 27px;
	text-transform: uppercase;

	color: #72738e;
}
</style>
